/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Steps_Photo_BodyInputs */

const en_road_dude_steps_photo_body = /** @type {(inputs: Road_Dude_Steps_Photo_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use an evenly lit photo with one face and a simple background. Keep your pet’s eyes and muzzle visible.`)
};

const zh_road_dude_steps_photo_body = /** @type {(inputs: Road_Dude_Steps_Photo_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择光线均匀、背景简单的单人或单只宠物照片，尽量露出眼睛和嘴部。`)
};

/**
* | output |
* | --- |
* | "Use an evenly lit photo with one face and a simple background. Keep your pet’s eyes and muzzle visible." |
*
* @param {Road_Dude_Steps_Photo_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_steps_photo_body = /** @type {((inputs?: Road_Dude_Steps_Photo_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Steps_Photo_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_steps_photo_body(inputs)
	return zh_road_dude_steps_photo_body(inputs)
});
export { road_dude_steps_photo_body as "road_dude.steps.photo.body" }